// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"135":"c05a1629","453":"fce86a0d"}[chunkId] + ".chunk.js";
};